import { render, staticRenderFns } from "./AI-Bottom-ICP.vue?vue&type=template&id=1530ce2a&scoped=true&"
import script from "./AI-Bottom-ICP.vue?vue&type=script&lang=js&"
export * from "./AI-Bottom-ICP.vue?vue&type=script&lang=js&"
import style0 from "./AI-Bottom-ICP.vue?vue&type=style&index=0&id=1530ce2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530ce2a",
  null
  
)

export default component.exports